import { Grid, Button } from '@material-ui/core'
import { useNotify } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const DeleteButton = (props) => {
  const { record, setIsChanged } = props
  const notify = useNotify()
  const classes = useStyles()

  // today, user cannot create resolution directly on HelloApp. Then can only create subresolution.
  // So we only allow to delete subresolutions
  if (record.parent_id == null) return null

  const deleteResolution = (e) => {
    e.preventDefault()
    Api.resolutions
      .delete(record.id)
      .then((res) => {
        setIsChanged(new Date())
        notify('Succès')
      })
      .catch((err) => {
        notify(`${err.data.message}`, 'warning')
      })
  }

  return (
    <Grid item xs={12}>
      <Button
        variant="contained"
        color="secondary"
        className={classes.actionButton}
        size="normal"
        onClick={deleteResolution}
      >
        Supprimer
      </Button>
    </Grid>
  )
}
export default DeleteButton
